import styled from "styled-components";

export default styled.div`
  .info-content {
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-around;
    gap: 0.5rem;
    opacity: 0.2rem;

    .info-content-line {
      flex: 1;
      display: flex;
      align-items: flex-end;

      &--right {
        justify-content: flex-start;
      }

      &--left {
        justify-content: flex-end;
      }

      .info-content-line-content {
        height: 1px;
        background-color: rgb(150, 150, 150);
        width: 90%;
        margin-bottom: 0.3rem;
        border-radius: 0.5px;
        opacity: 0.2;
      }
    }
    .info-content-text {
      .MuiTypography-root {
        color: rgb(150, 150, 150);
        opacity: 0.9;
      }
    }
  }
`;
